import { OptionDto } from "@/dtos";
import { DepositType } from "@/helpers/types";

const depositTypes = [
    { value: DepositType.DEPOSIT, label: 'Depósito' },
    { value: DepositType.TRANSFER, label: 'Transferencia Bancaria' },
    { value: DepositType.CASH, label: 'Efectivo' },
] as OptionDto[];

export const getDepositTypeOptions = (): OptionDto[] => {
    return depositTypes;
}

export const getDepositTypeOption = (value?: number): OptionDto => {
    return depositTypes.find((x) => x.value == value) ?? depositTypes[0];
}

export const getDepositTypeLabel = (value: number): string => {
    return depositTypes.find((x) => x.value == value)?.label ?? depositTypes[0].label;
}